import React from "react";
import { Link, useLocation, useRouteMatch } from "react-router-dom";
import classNames from "classnames";

import { createLocation } from "history";
import { NAV_LINK_CLASS_NAMES } from "../NavLink.constants";
import { NavLinkProps } from "../NavLink.types";

const RouteLink: React.FC<NavLinkProps> = ({ children, className, to, exact, isMatchOverride, onClick }) => {
   const currentLocation = useLocation();
   const normalizedLocation = createLocation(to, null, undefined, currentLocation);

   const routeMatch = useRouteMatch({
      path: normalizedLocation.pathname,
      exact: exact
   });
   const isMatch = isMatchOverride ? isMatchOverride(to, !!routeMatch) : routeMatch;
   const linkClassNames = classNames(NAV_LINK_CLASS_NAMES.nav, { [NAV_LINK_CLASS_NAMES.navActive]: isMatch }, className);


   return (<Link to={to} className={linkClassNames} onClick={onClick}>
      {children}
   </Link>);
}

export default RouteLink;